import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";

import PropTypes from "prop-types";

import WebSocketService, {
  NOTIFICATION_CENTER_EVENTS,
  WEBSOCKET_EVENT_NOTIFY,
} from "Services/websocket";
import { NOTIFICATION_TYPE_SINGLE } from "Services/notification";

import { loadNotifications as loadNotificationsAction } from "actions/singleNotifications";

import notificationMessageShape from "../notificationMessage.shape";
import SingleNotification from "../SingleNotification";

const SingleNotificationList = ({
  messages,
  loadNotifications,
  isWebsocketAvailable,
}) => {
  useEffect(() => {
    loadNotifications();

    if (!isWebsocketAvailable) {
      return;
    }

    WebSocketService.addListener(WEBSOCKET_EVENT_NOTIFY, (data) => {
      if (
        data.type === NOTIFICATION_CENTER_EVENTS &&
        data.level === NOTIFICATION_TYPE_SINGLE
      ) {
        loadNotifications();
      }
    });
  }, [isWebsocketAvailable, loadNotifications]);

  return (
    <Fragment>
      {messages.map((message) => (
        <SingleNotification message={message} key={message.id} />
      ))}
    </Fragment>
  );
};

SingleNotificationList.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.shape(notificationMessageShape)),
  loadNotifications: PropTypes.func.isRequired,
  isWebsocketAvailable: PropTypes.bool.isRequired,
};

SingleNotificationList.defaultProps = {
  messages: [],
};

const mapStateToProps = (store) => {
  return {
    messages: store.singleNotifications.messages,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadNotifications: () => dispatch(loadNotificationsAction()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SingleNotificationList);
